import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import WatchAdsCreateEditForm from './Components/WatchAdsCreateEditForm';
import WatchAdsApi from './WatchAdsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: WatchAdsCreateEditForm,
                getCreate: WatchAdsApi.create,
                getClone: WatchAdsApi.getOne,
                defaults: {},
                successMessage: "WatchAds Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}